var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "page-card",
    [
      _c("template", { slot: "header" }, [
        _c("span", [_vm._v("Personal Verification")]),
      ]),
      _vm._v(" "),
      _c(
        "div",
        { attrs: { slot: "body" }, slot: "body" },
        [
          _c(_vm.areaComp[_vm.area], {
            ref: "areaComp",
            tag: "component",
            attrs: { area: _vm.area },
          }),
        ],
        1
      ),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }